/**
 * Recordings API — upload audio blobs from Speaking-Lab pages to R2 via backend.
 * Uses XHR (like dashboardService) to bypass Emergent's fetch wrapper.
 */
const API = process.env.REACT_APP_BACKEND_URL;

function _token() {
  return localStorage.getItem('selora_token') || '';
}

/**
 * Upload a recorded audio blob together with activity metadata.
 * @returns Promise<{recording_id, submission_id, playback_url, size_bytes, created_at}>
 */
export function uploadRecording(blob, {
  level,
  exerciseId,
  exerciseTitle,
  promptId = '',
  promptText = '',
  durationSeconds = null,
} = {}) {
  return new Promise((resolve, reject) => {
    if (!blob) return reject(new Error('No audio to upload'));
    const token = _token();
    if (!token) return reject(new Error('Not authenticated'));

    const fd = new FormData();
    fd.append('file', blob, 'recording.webm');
    fd.append('level', level || '');
    fd.append('exercise_id', exerciseId || '');
    fd.append('exercise_title', exerciseTitle || '');
    if (promptId) fd.append('prompt_id', promptId);
    if (promptText) fd.append('prompt_text', promptText);
    if (durationSeconds != null) fd.append('duration_seconds', String(durationSeconds));

    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API}/api/recordings/upload`, true);
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.onload = () => {
      let data = {};
      // Response body is expected JSON but backend may 204/empty on some paths.
      // A malformed body should not crash the caller — surface HTTP status instead.
      try { data = JSON.parse(xhr.responseText || '{}'); } catch (parseErr) { console.warn('recordingsService: bad JSON body', parseErr); }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(data.detail || `Upload failed (HTTP ${xhr.status})`));
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(fd);
  });
}

export function listMyRecordings() {
  return _get('/api/recordings/mine');
}

export function getRecordingForSubmission(submissionId) {
  return _get(`/api/recordings/for-submission/${submissionId}`);
}

function _get(path) {
  const token = _token();
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${API}${path}`, true);
    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.onload = () => {
      let data = {};
      // Body may be empty/malformed on some endpoints; surface HTTP status either way.
      try { data = JSON.parse(xhr.responseText || '{}'); } catch (parseErr) { console.warn('recordingsService: bad JSON body', parseErr); }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(data.detail || `HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send();
  });
}
